import { useCallback } from "react";
import { useSelector } from "react-redux";
import { Outlet, useParams } from "react-router-dom";
import HasRequiredAuthority from "../dependencies/HasRequiredAuthority";
import { AUTHORITIES } from "../../constants";

export default function User() {
    const { userId } = useParams();

    const { roles = [] } = useSelector((state) => state.stateTemplateConfig?.global);
    const { courses = [] } = useSelector((state) => state.stateTemplateConfig?.global);
    const { branches = [] } = useSelector((state) => state.stateTemplateConfig?.global);

    const getCourseTitle = useCallback((courseId) => courses?.find((course) => course.id === courseId)?.title, [courses]);

    return (
        <HasRequiredAuthority requiredAuthority={AUTHORITIES.USE_CONTAINER_USER}>
            <div className="flex flex-column h-full overflow-hidden">
                <div className="flex-1 min-h-0 overflow-hidden flex flex-column">
                    <Outlet context={{ roles, userId, courses, branches, getCourseTitle }} />
                </div>
            </div>
        </HasRequiredAuthority>
    );
}
